/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementEmailConfDto } from '../../models/agreement-email-conf-dto';
import { BaseResponse } from '../../models/base-response';

export interface CommonControllerSetAgreementCreationConfiguration$Params {
      body: AgreementEmailConfDto
}

export function commonControllerSetAgreementCreationConfiguration(http: HttpClient, rootUrl: string, params: CommonControllerSetAgreementCreationConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerSetAgreementCreationConfiguration.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: string;
      }>;
    })
  );
}

commonControllerSetAgreementCreationConfiguration.PATH = '/common/sendAgreementCreationMailConfiguration';
